module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_minischool_m.a876881d85d4ade19945eb9bccce189d.png";